import { IApplicationState } from '../../types/redux';

export function getUpcomingSaleNewbuildingId(state: IApplicationState): number | null {
  return state.upcomingSale.newbuildingId;
}
